import React, { useEffect, useState } from "react";
import SapakimHead from "./SapakimHead";
import { db } from "../Components/Firebase";
import { collection, getDocs } from "firebase/firestore";
import { useParams } from "react-router-dom";
import '../Styles/Sapakim/SViewItem.css';

function SViewItem() {
    const { iid } = useParams();
    const [items, setItems] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null); // for modal

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const itemsRef = collection(db, "Catalog", iid, "Item");
                const snapshot = await getDocs(itemsRef);
                const itemsList = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setItems(itemsList);
            } catch (error) {
                console.error("Error fetching items: ", error);
            }
        };

        if (iid) {
            fetchItems();
        }
    }, [iid]);

    return (
        <>
            <SapakimHead />
            <div className="sviewitem-container">
                {items.length === 0 ? (
                    <p>לא נמצאו פריטים</p>
                ) : (
                    items.map((item) => (
                        <div key={item.id} className="item-card">
                            <h3>{item.name}</h3>
                            <p>{item.info}</p>
                            <h4>תמונות:</h4>
                            {item.images && item.images.length > 0 && (
                                <div className="media-gallery images">
                                    {item.images.map((imgUrl, index) => (
                                        <img
                                            key={index}
                                            src={imgUrl}
                                            alt={`item-${index}`}
                                            className="item-image"
                                            onClick={() => setSelectedImage(imgUrl)}
                                        />
                                    ))}
                                </div>
                            )}

                            {item.videos && item.videos.length > 0 && (
                                <div className="media-gallery">
                                    <h4>סרטונים:</h4>
                                    {item.videos.map((videoUrl, index) => (
                                        <video key={index} controls className="item-video">
                                            <source src={videoUrl} type="video/mp4" />
                                            הדפדפן שלך אינו תומך בסרטון
                                        </video>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>

            {selectedImage && (
                <div className="image-modal" onClick={() => setSelectedImage(null)}>
                    <img src={selectedImage} alt="תמונה גדולה" className="modal-image" />
                </div>
            )}
        </>
    );
}

export default SViewItem;
